module.exports = __webpack_public_path__ + "static/media/target.ea7fd3ea.svg";